import request from '@/utils/request'

let Vip_serviceApi = {

  /*vip服务列表*/
  list(data) {
    return request._post('/shop/plus.vip_service.Index/index', data);
},
/*添加vip服务*/
add(data) {
    return request._post('/shop/plus.vip_service.Index/add', data);
},
/*修改vip服务*/
edit(data) {
    return request._post('/shop/plus.vip_service.Index/edit', data);
},
/*删除vip服务*/
del(data) {
    return request._post('/shop/plus.vip_service.Index/del', data);
},
/*vip服务详情*/
detail(data) {
  return request._post('/shop/plus.vip_service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vip_service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vip_service.Setting/getSetting', data, errorback);
    },
}
export default Vip_serviceApi;



// WEBPACK FOOTER //
// ./src/api/vip_service.js